export default {"src":"/_next/static/media/axios.3f06155c.svg","height":372,"width":2500,"blurWidth":0,"blurHeight":0};